import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Menu, MenuItem, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
const UserInfo = ({ profileData }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    localStorage.removeItem('data');
    localStorage.removeItem('token');

    console.log('logout called');
    navigate('/login/admin');
  };

  const menuItems = [
    { label: 'Dashboard', path: '/dashboard/home' },
    { label: 'Profile', path: '/dashboard/editadmin' },
  ];

  return (
    <div className="flex items-center">
      <div className="relative">
        <button onClick={handleMenuOpen} className="flex items-center gap-2 font-semibold cursor-pointer">
          <span>{profileData?.display_name || `${profileData?.first_name || ''} ${profileData?.last_name || ''}`}</span>
          <Avatar
            className="h-12 w-12"
            src={`https://api.fly-inn.com/storage/profile/${profileData?.image}`}
            alt={profileData?.display_name}
          />
        </button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          //   classes={{ paper: 'bg-white shadow-lg' }}
        >
          <MenuItem>
            <InfoComp
              img={`https://api.fly-inn.com/storage/profile/${profileData?.image}`}
              name={profileData?.display_name}
              email={profileData?.email}
            />
          </MenuItem>

          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                handleMenuClose();
                if (item.action) {
                  item.action();
                }
              }}
              component={item.action ? 'button' : Link}
              to={item.path}
              className="hover:bg-gray-100"
            >
              <ListItemText primary={item.label} className="text-gray-800" />
            </MenuItem>
          ))}

          <MenuItem
            onClick={() => {
              logOut();
              handleMenuClose();
            }}
            component={'button'}
            className="hover:bg-gray-100 w-[90%] m-auto rounded-md mt-2"
            style={{ border: '1px dotted' }}
          >
            <ListItemText primary="Logout" className="text-gray-800" />
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default UserInfo;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: '#4caf50', // Green color for online
      color: '#4caf50',
      borderRadius: '50%',
      height: 12,
      width: 12,
      border: `2px solid ${theme.palette.background.paper}`,
    },
  },
  proBadge: {
    backgroundColor: '#e3f2fd',
    color: '#2196f3',
    padding: '2px 8px',
    borderRadius: 12,
    fontSize: '0.75rem',
    fontWeight: 600,
    marginLeft: theme.spacing(1),
  },
}));

const InfoComp = ({ img, name, email }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Avatar
        className={classes.avatar}
        alt={name}
        src={img} // Replace with the actual image URL
      />
      <Box>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {email}
        </Typography>
      </Box>
      <Typography className={classes.proBadge}>Admin</Typography>
    </Box>
  );
};
